export default __webpack_public_path__ + "static/media/S2.784c878b.svg";